"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bip39_1 = require("bip39");
const tfchain_encoding_siabin_1 = require("../tfchain/tfchain.encoding.siabin");
const ts_lib_crypto_1 = require("@waves/ts-lib-crypto");
const stellar_sdk_1 = require("stellar-sdk");
const tweetnacl_ts_1 = require("tweetnacl-ts");
const mnemonicconversion2924_1 = require("mnemonicconversion2924");
exports.decodeHex = hexString => {
    return new Uint8Array(hexString.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
};
exports.encodeHex = bytes => {
    return bytes.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
};
function calculateWalletEntropyFromAccount(seedPhrase, walletIndex) {
    var seed = getSeedFromSeedPhrase(seedPhrase);
    if (seed.length >= 33) {
        seed = seed.slice(0, 32);
    }
    if (walletIndex == -1) {
        return seed;
    }
    const encoder = tfchain_encoding_siabin_1.SiaBinaryEncoder();
    encoder.add_array(seed);
    if (walletIndex != -1 && seed.length === 32) {
        encoder.add_int(walletIndex);
    }
    // h in go file
    const blake2b1Hash = ts_lib_crypto_1.blake2b(encoder.data);
    return blake2b1Hash;
}
exports.calculateWalletEntropyFromAccount = calculateWalletEntropyFromAccount;
function keypairFromAccount(walletEntropy) {
    return stellar_sdk_1.Keypair.fromRawEd25519Seed(walletEntropy);
}
exports.keypairFromAccount = keypairFromAccount;
exports.revineAddressFromSeed = (seedPhrase, walletIndex) => {
    var entropy = getSeedFromSeedPhrase(seedPhrase);
    if (entropy.length >= 33) {
        entropy = entropy.slice(0, 32);
    }
    let encoder = tfchain_encoding_siabin_1.SiaBinaryEncoder();
    encoder.add_array(entropy);
    if (walletIndex != -1) {
        encoder.add_int(walletIndex);
    }
    const seed = ts_lib_crypto_1.blake2b(encoder.data);
    const asyncKeyPair = tweetnacl_ts_1.sign_keyPair_fromSeed(seed);
    const publicKey = asyncKeyPair.publicKey;
    const prefix1 = new Uint8Array([101, 100, 50, 53, 53, 49, 57, 0, 0, 0, 0, 0, 0, 0, 0, 0, 32, 0, 0, 0, 0, 0, 0, 0]);
    const prefix2 = new Uint8Array([56, 0, 0, 0, 0, 0, 0, 0]);
    const encodedData = new Uint8Array([...prefix2, ...prefix1, ...publicKey]);
    var hash = ts_lib_crypto_1.blake2b(encodedData);
    var publicKeyAsHex = exports.encodeHex(hash);
    const uint8Array = new Uint8Array([1, ...hash]);
    const blake2b1 = ts_lib_crypto_1.blake2b(uint8Array);
    const bytes = blake2b1.slice(0, 6);
    var checksum = exports.encodeHex(bytes);
    return `01${publicKeyAsHex}${checksum}`;
};
function seedPhraseFromStellarSecret(secret) {
    const pair = stellar_sdk_1.Keypair.fromSecret(secret);
    const entropy = pair.rawSecretKey();
    const mnemonic = bip39_1.entropyToMnemonic(entropy);
    return mnemonic;
}
exports.seedPhraseFromStellarSecret = seedPhraseFromStellarSecret;
function getSeedFromSeedPhrase(seedPhrase) {
    const splitSeedPhrase = seedPhrase.split(' ');
    if (splitSeedPhrase.length === 29) {
        return mnemonicconversion2924_1.getEntropyFromPhrase(splitSeedPhrase);
    }
    // App wallets
    if (splitSeedPhrase.length === 25 && splitSeedPhrase[splitSeedPhrase.length - 1] === 'stellar') {
        splitSeedPhrase.pop();
        seedPhrase = splitSeedPhrase.join(' ');
        const entropy = bip39_1.mnemonicToEntropy(seedPhrase);
        var original = exports.decodeHex(entropy);
        var arr = [].slice.call(original);
        arr.add(0);
        var modified = Uint8Array.from(arr);
        return modified;
    }
    else {
        const entropy = bip39_1.mnemonicToEntropy(seedPhrase);
        return exports.decodeHex(entropy);
    }
}
//# sourceMappingURL=cryptoService.js.map